import React, { useContext } from "react";

import { FormContext } from "./FormContext";
import { FormActionTypes } from "./formInterfaces";
import { Button } from "../inputs/Button";

type Props = {
  label: string;
  onReset?: () => void;
};

export const ResetButton: React.FC<Props> = props => {
  const { dispatch } = useContext(FormContext);

  return (
    <Button
      style={{ marginRight: "1em" }}
      onClick={() => {
        dispatch({
          type: FormActionTypes.reset
        });
        if (props.onReset) {
          props.onReset();
        }
      }}
      id="reset"
    >
      {props.label}
    </Button>
  );
};
